<template>
    <div class="dating-style" :class="{ mobile: $store.getters.isMobile }">
        <div class="title" v-html="'소개팅 스타일'" />
        <div class="content">
            <div class="dating-style-container" :key="idx" v-for="(dating, idx) in datings">
                <div class="question" v-html="`Q. ${dating.question}`" />
                <div class="answer" :key="idx" v-for="(answer, idx) in dating.answer" v-html="answer" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'DatingStyles',
    props: ['user'],
    computed: {
        datings() {
            if (!this.user) return

            const datings = this.user.dating_preferences || []
            const datingsList = []

            datings.map(d => {
                if (datingsList[d.dating_preference_id - 1]) {
                    datingsList[d.dating_preference_id - 1].answer.push(d.answer)
                } else {
                    datingsList[d.dating_preference_id - 1] = { question: d.question, answer: [d.answer] }
                }
            })

            return datingsList.filter(x => x.question)
        },
    },
}
</script>

<style lang="scss" scoped>
.dating-style {
    margin-top: 20px;

    .title {
        font-size: 15px;
        font-weight: 500;
        color: $black;
        font-family: NotoSans-Medium;
        margin-bottom: 12px;
    }
    .content {
        display: flex;
        flex-wrap: wrap;

        .dating-style-container {
            width: 48%;
            padding: 8px 12px;
            border-radius: 12px;
            // width: fit-content;
            height: fit-content;
            background-color: $grey-01;
            margin-bottom: 8px;
            margin-right: 8px;

            .question {
                font-family: NotoSans-Medium;
                font-size: 11px;
                font-weight: 500;
                color: $black;
                margin-bottom: 8px;
            }
            .answer {
                font-size: 11px;
                font-weight: normal;
                color: $grey-09;
            }
        }
    }

    &.mobile {
        padding: 24px 16px;
        margin-top: 0px;

        .title {
            font-size: 18px;
            font-weight: 500;
            color: $black;
            font-family: NotoSans-Medium;
            margin-bottom: 24px;
        }
        .dating-style-container {
            width: 100%;
            padding: 12px 16px;
            border-radius: 12px;
            // width: fit-content;
            height: fit-content;
            background-color: $grey-01;
            margin-bottom: 16px;

            .question {
                font-family: NotoSans-Medium;
                font-size: 14px;
                font-weight: 500;
                color: $black;
                margin-bottom: 8px;
            }
            .answer {
                font-size: 14px;
                font-weight: normal;
                color: $grey-09;
            }
        }
    }
}
</style>
